import { jsxs, jsx } from "react/jsx-runtime";
const IconListSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9 8h10c.6 0 1-.4 1-1s-.4-1-1-1H9c-.6 0-1 .4-1 1s.4 1 1 1zm10 3H9c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1zm0 5H9c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1z" }),
      /* @__PURE__ */ jsx("circle", { cx: 5, cy: 7, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 5, cy: 12, r: 1 }),
      /* @__PURE__ */ jsx("circle", { cx: 5, cy: 17, r: 1 })
    ]
  }
);
export {
  IconListSvg
};
